import Client from '@spike/client-model';
import { PetsSaveError } from '@spike/pets-action';
import { ClientExpiredVaccinesDto } from 'actions/updateExpiredVaccines/UpdateExpiredVaccinesDto';

export interface UpdateExpiredVaccinesState {
    clientExpiredVaccines: ClientExpiredVaccinesDto | null;
    status: UpdateExpiredVaccinesStatus;
    // `loading` and `error` describe resolving the client link only. A failed
    // save must not touch them, or the page falls back to "Client Not Found".
    loading: boolean;
    error: boolean;
    saving: boolean;
    saveError?: PetsSaveError;
}

export enum UpdateExpiredVaccinesStatus {
    Initial,
    Getting,
    GettingSuccess,
    SaveSuccess,
    Error
}
